import React, { FC, useEffect } from 'react';
import { Skeleton } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getAnalyzeChannelsChannelShareShiftsModel } from 'app/store/reducers/analyzeChannels.reducer';
import { IAnalyzeChannelsChannelShareParams } from 'entities/AnalyzeChannels/AnalyzeChannels.models';
import { AnalyzeChannelsChannelShareShiftCard } from 'entities/AnalyzeChannels/components/AnalyzeChannelsChannelShareShiftCard';

interface IComponentProps {
  params?: IAnalyzeChannelsChannelShareParams;
}

export const AnalyzeChannelsChannelShareShiftsBlock: FC<IComponentProps> = ({ params }) => {
  const dispatch = useAppDispatch();

  const { analyzeChannelsChannelShareShiftsModel, analyzeChannelsChannelShareShiftsModelLoading } = useAppSelector(
    (state) => state.analyzeChannels
  );

  useEffect(() => {
    dispatch(getAnalyzeChannelsChannelShareShiftsModel(params));
  }, [params?.storeCode, params?.week]);

  const shifts = analyzeChannelsChannelShareShiftsModel?.shifts ?? [];

  return (
    <div className="flex ac-channel-share-shifts">
      {analyzeChannelsChannelShareShiftsModelLoading ? (
        <>
          <div className="p-5 ac-channel-share-shift-card">
            <Skeleton className="pb-5" active paragraph={{ rows: 4 }} title={false} />
            <Skeleton active paragraph={{ rows: 4 }} title={false} />
          </div>
          <div className="p-5 ac-channel-share-shift-card">
            <Skeleton className="pb-5" active paragraph={{ rows: 4 }} title={false} />
            <Skeleton active paragraph={{ rows: 4 }} title={false} />
          </div>
          <div className="p-5 ac-channel-share-shift-card">
            <Skeleton className="pb-5" active paragraph={{ rows: 4 }} title={false} />
            <Skeleton active paragraph={{ rows: 4 }} title={false} />
          </div>
        </>
      ) : (
        <>
          {shifts.map((item, index) => {
            return <AnalyzeChannelsChannelShareShiftCard key={index} shift={item} index={index + 1} />;
          })}
        </>
      )}
    </div>
  );
};
